import { render, staticRenderFns } from "./generalization-list.vue?vue&type=template&id=11d3fa44&scoped=true"
import script from "./generalization-list.vue?vue&type=script&lang=js"
export * from "./generalization-list.vue?vue&type=script&lang=js"
import style0 from "./generalization-list.vue?vue&type=style&index=0&id=11d3fa44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3fa44",
  null
  
)

export default component.exports